import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import settings from "./settings"
import activity from "./activity"
import auth from "./auth";
import record from "./record";
import badges from "./badges";

const vuexLocalStorage = new VuexPersist({
    key: 'oms',
    storage: window.localStorage,
    reducer: state => ({
        settings: state.settings,
        auth: state.auth,
        badges: state.badges,
    })
    // Function that passes a mutation and lets you decide if it should update the state in localStorage.
    // filter: mutation => (true)
})

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        first: true,
        warehouse: null,
        printing: false
    },
    getters: {
        is_first: (state) => state.first
    },
    mutations: {
        clear_first: (state) => state.first = false
    },
    modules: {
        settings,
        activity,
        record,
        auth,
        badges
    },
    plugins: [vuexLocalStorage.plugin]
})